module.exports = __webpack_public_path__ + "home_s2_1.png?52c5721eeed9ac14ef3ba0c0b97c324c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_s2_1.png
// module id = 4
// module chunks = 0